import React from "react";
import { ComparisonPeriod } from "@radarly/models/cards/period";
import { DatavizHorizontalBarChart } from "@radarly/models/dataviz";
import { SearchFragmentClassification } from "@radarly/models/search";
import HorizontalBarChart from "../../dataviz/horizontal-bar-chart";
import { useHorizontalBarChart } from "./model";

export interface ClassificationHorizontalBarChartProps {
  loading: boolean;
  data: SearchFragmentClassification["data"];
  comparaisonData: SearchFragmentClassification["data"];
  fragment: SearchFragmentClassification;
  dataviz: DatavizHorizontalBarChart;
  className?: string;
  onClickItem?: (uid: string | number) => void;
  disableAnimation?: boolean;
  comparisonPeriod: ComparisonPeriod;
  isFullscreen?: boolean;
}

export default function ClassificationHorizontalBarChart({
  loading,
  data,
  comparaisonData,
  fragment,
  dataviz,
  className,
  onClickItem,
  disableAnimation,
  comparisonPeriod,
  isFullscreen,
}: ClassificationHorizontalBarChartProps) {
  const { total, range, gauges, metric } = useHorizontalBarChart({
    loading,
    dataviz,
    data,
    comparaisonData,
    fragment,
  });
  return (
    <HorizontalBarChart
      gauges={gauges}
      className={className}
      onClickGauge={onClickItem}
      range={range}
      metric={metric}
      dataviz={dataviz}
      total={total}
      disableAnimation={disableAnimation}
      comparisonPeriod={comparisonPeriod}
      isFullscreen={isFullscreen}
    />
  );
}
